NtechApp.SizesResolver = function() {
    this._dom = new NtechApp.Dom();
    this._getCompCssFn  = null;

    this._init();
};

NtechApp.proto(NtechApp.SizesResolver, {
    _init: function() {
        if(window.getComputedStyle) {
            this._getCompCssFn = function(item) {
                return window.getComputedStyle(item, null);
            }
        }
        else {
            this._getCompCssFn = function(item) {
                return item.currentStyle;
            }
        }
    },

    getComputedCss: function(item) {
        return this._getCompCssFn(this._dom.isJquery(item) ? item.get(0) : item);
    },

    flushComputedStyles: function(item) {
        var item = this._dom.isJquery(item) ? item.get(0) : item;
        this.getComputedCss(item).opacity;
    }
});